import { string } from "prop-types"
import DatePicker from "components/ui/DatePicker"
import TimePicker from "components/ui/TimePicker"
import { useState } from "react"
import DuplicationAlert from "./DuplicationAlert"

const DuplicationForm = ({
  action,
  name,
  registrationType,
  startsAt: initialStartsAt,
  openAt,
  closeAt,
  showAt,
  hideAt
}) => {
  const [startsAt, setStartsAt] = useState(initialStartsAt)
  const shouldAdjustTimes = initialStartsAt !== null

  return (
    <form
      className="new_event"
      id="new_event"
      action={action}
      acceptCharset="UTF-8"
      data-remote="true"
      method="post"
    >
      <div className="mb-2">
        <label htmlFor="event_Name">Name</label>
        <input
          placeholder="Name"
          maxLength="255"
          size="255"
          type="text"
          defaultValue={name}
          name="event[name]"
          id="event_name"
          className=""
        />
      </div>

      {shouldAdjustTimes && (
        <div className="d-f mb-3">
          <div className="f-1 pr-1">
            <label htmlFor="event_starts_at_date">Start date</label>
            <DatePicker
              id="starts_at_date"
              name="starts_at_date"
              datetime={startsAt}
              onChange={setStartsAt}
            />
          </div>
          <div className="f-1 pl-1">
            <label htmlFor="event_starts_at_time">Start time</label>
            <TimePicker
              type="text"
              name="starts_at_time"
              id="starts_at_time"
              datetime={startsAt}
              onChange={setStartsAt}
              mobileBrowser={window.isMobile}
            />
          </div>
        </div>
      )}

      <h3 className="label mb-1">Include</h3>
      <div className="d-f mb-2">
        <div className="f-1">
          <input
            type="checkbox"
            name="copy_categories"
            id="copy_categories"
            className="checkbox"
            defaultChecked="checked"
          />
          <label className="checkbox-label" htmlFor="copy_categories">
            Categories
          </label>
        </div>
        <div className="f-1">
          <input
            type="checkbox"
            name="copy_event_managers"
            id="copy_event_managers"
            className="checkbox"
            defaultChecked="checked"
          />
          <label className="checkbox-label" htmlFor="copy_event_managers">
            Managers
          </label>
        </div>
      </div>
      <div className="d-f mb-2">
        <div className="f-1">
          <input
            type="checkbox"
            name="copy_campuses"
            id="copy_campuses"
            className="checkbox"
            defaultChecked="checked"
          />
          <label className="checkbox-label" htmlFor="copy_campuses">
            Campuses
          </label>
        </div>
        <div className="f-1">
          <input
            type="checkbox"
            name="copy_event_location"
            id="copy_event_location"
            className="checkbox"
            defaultChecked="checked"
          />
          <label className="checkbox-label" htmlFor="copy_event_location">
            Location
          </label>
        </div>
      </div>
      <div className="d-f mb-2">
        <div className="f-1">
          <input
            type="checkbox"
            name="copy_questions"
            id="copy_questions"
            className="checkbox"
            defaultChecked="checked"
          />
          <label className="checkbox-label" htmlFor="copy_questions">
            Questions
          </label>
        </div>
        {registrationType === "detailed" && (
          <div className="f-1">
            <input
              type="checkbox"
              name="copy_forms"
              id="copy_forms"
              className="checkbox"
              defaultChecked="checked"
            />
            <label className="checkbox-label" htmlFor="copy_forms">
              Forms
            </label>
          </div>
        )}
      </div>

      {registrationType === "detailed" && (
        <>
          <div className="d-f mb-2">
            <div className="f-1">
              <input
                type="checkbox"
                name="copy_add_ons"
                id="copy_add_ons"
                className="checkbox"
                defaultChecked="checked"
              />
              <label className="checkbox-label" htmlFor="copy_add_ons">
                Add-Ons
              </label>
            </div>
            <div className="f-1">
              <input
                type="checkbox"
                name="copy_discounts"
                id="copy_discounts"
                className="checkbox"
                defaultChecked="checked"
              />
              <label className="checkbox-label" htmlFor="copy_discounts">
                Discounts
              </label>
            </div>
          </div>
          <div className="d-f">
            <div className="f-1">
              <input
                type="checkbox"
                name="copy_assignment_types"
                id="copy_assignment_types"
                className="checkbox"
                defaultChecked="checked"
              />
              <label className="checkbox-label" htmlFor="copy_assignment_types">
                Assignment Types
              </label>
            </div>
            <div className="f-1">
              <input
                type="checkbox"
                name="copy_scholarships"
                id="copy_scholarships"
                className="checkbox"
                defaultChecked="checked"
              />
              <label className="checkbox-label" htmlFor="copy_scholarships">
                Scholarships
              </label>
            </div>
          </div>
        </>
      )}

      {shouldAdjustTimes && (
        <DuplicationAlert
          originalStartsAt={initialStartsAt}
          startsAt={startsAt}
          openAt={openAt}
          closeAt={closeAt}
          showAt={showAt}
          hideAt={hideAt}
        />
      )}
    </form>
  )
}

DuplicationForm.propTypes = {
  action: string.isRequired,
  name: string.isRequired,
  registrationType: string.isRequired,
  startsAt: string,
  openAt: string,
  closeAt: string,
  showAt: string,
  hideAt: string
}

export default DuplicationForm
